import OrdemServicoClienteService from "@/services/OrdemServicoClienteService";

export const ordemServicoCliente = {
  namespaced: true,
  state: {
    ordemServicoCliente: {},
  },
  actions: {
    getOrdemServicoCliente({ commit }, payload) {
      return OrdemServicoClienteService.GetOrdemServicoCliente(payload).then(
        (ordemServicoCliente) => {
          return Promise.resolve(ordemServicoCliente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postOrdemServicoCliente({ commit }, payload) {
      return OrdemServicoClienteService.PostOrdemServicoCliente(payload).then(
        (ordemServicoCliente) => {
          return Promise.resolve(ordemServicoCliente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putOrdemServicoCliente({ commit }, payload) {
      return OrdemServicoClienteService.PutOrdemServicoCliente(payload).then(
        (ordemServicoCliente) => {
          return Promise.resolve(ordemServicoCliente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteOrdemServicoCliente({ commit }, payload) {
      return OrdemServicoClienteService.DeleteOrdemServicoCliente(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getOrdemServicoClienteOData({ commit }, payload) {
      return OrdemServicoClienteService.GetOrdemServicoClienteOData(
        payload
      ).then(
        (ordemServicoCliente) => {
          return Promise.resolve(ordemServicoCliente);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default ordemServicoCliente;
